module.exports = __webpack_public_path__ + "img/aliex3.7fd2d2a3.jpg";